import API from 'app/utils/apiClient';
import { toParams } from 'app/utils/url';

const getCuration = (id) => API.get(`/curations/${id}/`);

const getInitialSection = (id) => {
  return API.get(`/sections/${id}/`);
};

const getSectionContents = (id, lastEvaluatedKey) => {
  const params = toParams({
    lastEvaluatedKey,
  });
  return API.get(`/sections/${id}/contents/?${params}`);
};

const getUsersBySection = (id, page = 1, perPage = 20) => {
  const params = toParams({
    page,
    perPage,
  });
  return API.get(`/sections/${id}/users/?${params}`);
};

export default {
  getCuration,
  getInitialSection,
  getSectionContents,
  getUsersBySection,
};



// WEBPACK FOOTER //
// ./src/app/apis/section.js